import * as types from "./types";

const initialState = {
  rows: [],
  loading: false,
  error: null,
};

export default function processorReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ROWS:
      return {
        ...state,
        rows: action.payload,
      };

    case types.FETCH_DROPDOWN:
      return {
        ...state,
        dropdown: action.payload,
      };
    case types.EDIT_PROCESS_DATA:
      return {
        ...state,
        edited: action.payload,
      };
      

   
    default:
      return state;
  }
}
